import { render, staticRenderFns } from "./SimilarItemsFiltersLikePatternBrand.vue?vue&type=template&id=8d14a95a&"
import script from "./SimilarItemsFiltersLikePatternBrand.vue?vue&type=script&lang=js&"
export * from "./SimilarItemsFiltersLikePatternBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})
